import expenses from './expenses';
import expenseCategories from './expenseCategories';

export default {
  expenses,
  expenseCategories,
};
